import Vue from "vue";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import store from "./store";
import router from "./router";
import Faye from "faye";
import { injectFilters, injectInjectables, registerDirectives } from "./utils";
import CKEditor from "@ckeditor/ckeditor5-vue2";
import VueClipboard from "vue-clipboard2";
import keycloak from "@core/config/keycloak-config";

VueClipboard.config.autoSetContainer = true;
Vue.use(CKEditor);
Vue.use(Faye);
Vue.use(VueClipboard);
/** invoking global data from. country timezone etc */
//store.dispatch("app/getData");
/**
 * Injects injectables in the vue globally
 */
injectInjectables();

/**
 * Register directives in the vue globally
 */
registerDirectives();

/**
 * Injects filters and injectables in the vue instance globally
 */
injectFilters();
Vue.config.productionTip = false;
keycloak.init({
  onLoad: "check-sso",  // Automatically checks if the user is already logged in (SSO)
  checkLoginIframe: false,  // Disable periodic login iframe checks for simplicity, this reduces unnecessary requests for login state checks.
  pkceMethod: 'S256',  // Use the S256 PKCE method for enhanced security during the authentication flow.
}).then((authenticated)=>{
  if (!authenticated) {
    keycloak.login();
    return
  }
  // Attach the Keycloak instance to Vue's prototype for global access
  Vue.prototype.$keycloak = keycloak;
  new Vue({
    vuetify,
    store,
    router,
    render: (h) => h(App),
  }).$mount("#app");
})